module.exports = __webpack_public_path__ + "img/volunteer_milly_logo.0c9d99ad.svg";